import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { ProductosApiService } from '../../../../service/api/productos-api';
import { RequestHandler } from '../../../../service/OffService/request-handler';
import { Utils } from '../../../../common/utils';
import { BaseView } from '../../../base-view';
import { environment } from '../../../../../environments/environment';

import { ProductosModel } from 'src/app/models/productos/productos.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { ProductoBioFormDefinition } from './producto-bio-form/form-control/form-definition';

@Component({
    selector: 'app-producto-bio',
    standalone: false,
    templateUrl: './producto-bio.component.html',
    styleUrls: ['./producto-bio.component.css']
})
export class ProductosBioComponent extends BaseView<ProductosModel> implements OnInit, OnDestroy {
    public tableValues = new RequestHandler();
    public menuItemId = 'productos-bio';
    public appName = environment.appName;
    public showPrecio = environment.features.showPrecio;
    public showFertisComposicion = environment.features.showFertisComposicion;
    public canAddProductos = environment.features.canAddProductos;
    public canEditProductos = environment.features.canEditProductos;
    public canDeleteProductos = environment.features.canDeleteProductos;

    public getRequest: RequestHandler<ProductosModel[]> = this.productosApi.productos.GET;
    public deleteRequest: RequestHandler<ProductosModel> = this.productosApi.productos.DELETE;
    public buttonText = 'Añadir Bio';

    public override canShow: Record<string, boolean> = {};
    public override model: ProductosModel = { nombre: '', materia_activa: '' };
    public form: ProductoBioFormDefinition | null = null;
    public readonly serverUrl = environment.serverUrl;

    public cols: ColInterface[] = [
        {
            field: 'nombre',
            header: this.appName === 'vginer' ? 'Fertilizante' : 'Nombre o Marca Comercial',
            filter: '',
        },
        { field: 'composicion', header: 'Composición', visible: this.showFertisComposicion },
        {
            field: 'precio',
            header: this.appName === 'agrotata' ? 'Precio Coste' : 'Precio',
            filter: '',
            width: '80px',
            visible: this.showPrecio
        },
        {
            field: 'precio_venta',
            header: 'Precio de Venta',
            filter: '',
            width: '80px',
            visible: this.showPrecio && this.appName === 'agrotata'
        },
        { field: 'unidades', header: 'Ud Medida', filter: '', width: '120px' },
    ];

    constructor(public productosApi: ProductosApiService,
        private dashboardEvents: DashboardService,
        private router: Router) {
        super(dashboardEvents, productosApi.productos.GET);
    }

    public ngOnInit(): void {
        this.dashboardEvents.setSubmenuItem('productos', this.menuItemId);
        this.tableValues.isLoading = true;
        this.productosApi.productos.GET.safePerform();
        this.productosApi.productos.GET.response(data => {
            this.tableValues.emitResponse(data.filter((item: ProductosModel) => {
                this.tableValues.isLoading = false;

                return item.tipo === 'bio';
            }));
        });
    }

    public globalConditionalStyle(value: string, col: ColInterface): ColStylesInterface {
        if (col.field === 'nombre') {
            return {
                textAlign: 'center'
            };
        }
        if (col.field === 'composicion') {
            return {
                textAlign: 'center'
            };
        }

        if (col.field === 'observaciones') {
            return {
                textAlign: 'left',
                paddingLeft: '35px',
            };
        }

        if (Utils.isNumber(value) || col.field === 'precio') {
            return {
                textAlign: 'right',
                paddingRight: '30px',
            };
        }

        if (Utils.isNumber(value) && col.field !== 'descripcion') {
            return {
                textAlign: 'right',
            };
        }

        return {};
    }

    public globalVisualTransform(value: string, col: ColInterface): string {
        if (Utils.isNumber(value) && col.field !== 'descripcion') {
            return Utils.decimalFormat(value, 2, '.', ',', 3);
        }

        if (col.field === 'descripcion') {
            return (value?.length > 25) ? value.slice(0, 25 - 1) + '…' : value;
        }

        return value;
    }

    public addProducto(): void {
        this.router.navigate(['dashboard', 'crear-producto-bio']);
    }

    public edit(data: ProductosModel): void {
        this.router.navigate(['dashboard', 'editar-producto-bio', data.id]);
    }

    public override deleteRegister(): void {
        if (this.model.id) {
            this.deleteRequest.safePerform(this.model);
            this.deleteRequest.response(() => {
                if (!this.deleteRequest.hasError) {
                    this.getRequest.safePerform();
                }
            });
        } else {
            this.deleteRequest.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
    }

    public override show(modal: string, data: ProductosModel, closePreviousModal: boolean = true): void {
        let x;

        this.model = (data as { data?: ProductosModel }).data ?? data;
        this.canShow[modal] = true;

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;

        this.form = new ProductoBioFormDefinition(formType, this.model);

        for (x in this.canShow) {
            if (x !== modal && this.canShow[x] && closePreviousModal) {
                this.canShow[x] = false;
            }
        }
    }

    public override hide(modal: string): void {
        this.model = { nombre: '', materia_activa: '' };
        this.canShow[modal] = false;
        this.deleteRequest.reset();
        this.form = null;
    }

    public goBack(): void {
        this.router.navigate(['dashboard', 'productos-bio']);
    }
}
